import { Suspense, useState, type ReactNode, type SuspenseProps } from 'react';
import { cn } from '../lib/utils';
import { Spinner } from './ui/spinner';

type StableHeightSuspenseProps = Omit<SuspenseProps, 'fallback'> & {
  fallback?: ReactNode;
  className?: string;
};

export function StableHeightSuspense({
  children,
  fallback = <Spinner />,
  className,
  ...suspenseProps
}: StableHeightSuspenseProps) {
  const [height, setHeight] = useState<number>();

  return (
    <Suspense
      {...suspenseProps}
      fallback={
        <div className="flex flex-1 items-center justify-center" style={{ height }}>
          {fallback}
        </div>
      }
    >
      <div
        className={cn('flex flex-1 flex-col', className)}
        ref={(e) => {
          if (e) setHeight(e.getBoundingClientRect().height);
        }}
      >
        {children}
      </div>
    </Suspense>
  );
}
